import {
  getSelectedNetworkActivitySettings,
  getSelectedOnBehalfOfUserId,
} from '@ms/yammer-data/dist/domains/analyticsSettings/selectors';

import { useSelector } from '../useSelector';

type UseSelectedOnBehalfOfUserId = () => ReturnType<typeof getSelectedOnBehalfOfUserId>;
export const useSelectedOnBehalfOfUserId: UseSelectedOnBehalfOfUserId = () => useSelector(getSelectedOnBehalfOfUserId);

type UseSelectedNetworkActivitySettings = () => ReturnType<typeof getSelectedNetworkActivitySettings>;
export const useSelectedNetworkActivitySettings: UseSelectedNetworkActivitySettings = () =>
  useSelector(getSelectedNetworkActivitySettings);
